import { assertCreationDateMarker } from './internal/assertCreationDateMarker';

export function ensureCreationDateMarker(name: unknown) {
  assertCreationDateMarker(name);
  return name;
}
